/* ============================================================
   Daps — Buy module (Shopify)
   ------------------------------------------------------------
   Drives every [data-buy-root]: flavor pills, subscribe/one-time
   toggle, pack radios, live prices + per-strip, variant image,
   sticky buy bar sync, and AJAX add-to-cart (with selling plan).

   All prices come from the JSON data island rendered by
   snippets/buy-module.liquid — nothing is hardcoded. Packs with
   no subscription selling plan auto-hide in subscribe mode.
   ============================================================ */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var get = function (k, d) { try { return localStorage.getItem(k) || d; } catch (e) { return d; } };
  var set = function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} };

  /* ---- money formatter (supports Shopify money_format tokens) ---- */
  function formatMoney(cents, format) {
    if (typeof cents !== "number") cents = parseInt(cents, 10) || 0;
    format = format || "${{amount}}";
    function num(n, precision, thousands, decimal) {
      if (isNaN(n)) n = 0;
      thousands = thousands || ","; decimal = decimal || ".";
      var neg = n < 0 ? "-" : ""; n = Math.abs(n);
      var s = (n / 100).toFixed(precision);
      var parts = s.split(".");
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      var frac = parts[1] ? decimal + parts[1] : "";
      return neg + whole + frac;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (_, token) {
      switch (token) {
        case "amount": return num(cents, 2);
        case "amount_no_decimals": return num(cents, 0);
        case "amount_with_comma_separator": return num(cents, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return num(cents, 0, ".", ",");
        case "amount_with_space_separator": return num(cents, 2, " ", ",");
        case "amount_with_apostrophe_separator": return num(cents, 2, "'", ".");
        case "amount_no_decimals_with_space_separator": return num(cents, 0, " ", "");
        default: return num(cents, 2);
      }
    });
  }

  function attr(el, name) { return el.getAttribute(name); }
  function isTrue(v) { return v === "true" || v === true; }

  function initModule(root) {
    if (root.dataset._inited) return;
    root.dataset._inited = "1";
    var dataEl = $(".buymod-data", root);
    if (!dataEl) return;
    var data;
    try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var variants = data.variants || [];
    if (!variants.length) return;
    var packMeta = data.packMeta || {};

    var moneyFormat = attr(root, "data-money-format") || "${{amount}}";
    var stripsUnit = parseInt(attr(root, "data-strips-unit"), 10) || 0;
    var showPerStrip = isTrue(attr(root, "data-show-per-strip")) && stripsUnit > 0;
    var perStripSuffix = attr(root, "data-per-strip-suffix") || "/ strip";
    var perk = attr(root, "data-subscribe-perk") || "";
    var labelSub = attr(root, "data-label-subscribe") || "subscribe & save";
    var labelOne = attr(root, "data-label-onetime") || "add to cart";
    var hasSub = isTrue(attr(root, "data-has-sub"));
    var afterAdd = attr(root, "data-after-add") || "cart";
    var cartUrl = attr(root, "data-cart-url") || "/cart";
    var cartAddUrl = attr(root, "data-cart-add-url") || "/cart/add.js";
    var qtyVal = $("[data-qty-val]", root);
    var qtySteps = $$("[data-qty-step]", root);
    var QTY_MAX = 20;
    var placement = attr(root, "data-placement") || "home";
    var defaultPack = attr(root, "data-default-pack") || "";
    var defaultFreq = attr(root, "data-default-freq") || "";

    var flavorDescMap = {};
    try { flavorDescMap = JSON.parse(attr(root, "data-flavor-desc-map") || "{}"); } catch (e) {}
    /* case-insensitive keys: block flavor_value ("peppermint") vs variant option ("Peppermint") */
    var flavorDescLC = {};
    for (var _dk in flavorDescMap) { if (flavorDescMap.hasOwnProperty(_dk)) flavorDescLC[String(_dk).toLowerCase()] = flavorDescMap[_dk]; }

    var money = function (c) { return formatMoney(c, moneyFormat); };

    /* ordered unique flavors + packs */
    var flavors = [], packs = [];
    variants.forEach(function (v) {
      if (v.flavor && flavors.indexOf(v.flavor) < 0) flavors.push(v.flavor);
      if (packs.indexOf(v.pack) < 0) packs.push(v.pack);
    });
    var hasFlavor = flavors.length > 0;

    /* subscription delivery frequencies (from each variant's selling plans), ordered by interval */
    function subsOf(v) { return (v && v.subs && v.subs.length) ? v.subs : (v && v.sub ? [v.sub] : []); }
    function freqNum(label) { var m = String(label || "").match(/\d+/); return m ? parseInt(m[0], 10) : 1; }
    function freqClean(label) { return String(label || "").replace(/^\s*deliver\s+/i, "").replace(/,.*$/, "").trim() || "each order"; }
    var freqs = [];
    variants.forEach(function (v) {
      subsOf(v).forEach(function (s) { if (s && s.label && freqs.indexOf(s.label) < 0) freqs.push(s.label); });
    });
    freqs.sort(function (a, b) { return freqNum(a) - freqNum(b); });

    var LSK = "daps_buy_" + placement;

    var state = {
      qty: 1,
      /* always start on the hero option (flavors[0]=Variety, packs[0]=4-Pack); subscription-first; monthly default */
      flavor: flavors[0] || "",
      pack: packs[0],
      mode: hasSub ? "subscribe" : "onetime",
      freq: freqs[0] || null
    };

    /* section-configured default pack (lenient match, like aov_pack) — e.g. start on the 80-strip pack */
    if (defaultPack) {
      var dpNeedle = defaultPack.replace(/\s/g, "").toLowerCase();
      for (var dpi = 0; dpi < packs.length; dpi++) {
        var dpHay = String(packs[dpi]).replace(/\s/g, "").toLowerCase();
        if (dpHay.indexOf(dpNeedle) === 0 || dpNeedle.indexOf(dpHay) === 0) { state.pack = packs[dpi]; break; }
      }
    }

    /* section-configured default delivery cadence (label-matched, e.g. "6 weeks") */
    if (defaultFreq) {
      var dfNeedle = defaultFreq.toLowerCase();
      for (var dfi = 0; dfi < freqs.length; dfi++) {
        if (String(freqs[dfi]).toLowerCase().indexOf(dfNeedle) >= 0) { state.freq = freqs[dfi]; break; }
      }
    }

    /* URL ?variant= preselect (e.g. from the "shop this flavor" links) — overrides saved state */
    try {
      var urlVariant = new URLSearchParams(window.location.search).get("variant");
      if (urlVariant) {
        for (var vi = 0; vi < variants.length; vi++) {
          if (String(variants[vi].id) === String(urlVariant)) {
            if (hasFlavor && variants[vi].flavor) state.flavor = variants[vi].flavor;
            state.pack = variants[vi].pack;
            if (hasSub && variants[vi].sub) state.mode = "subscribe";
            break;
          }
        }
      }
    } catch (e) {}

    function variantFor(flavor, pack) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        if (v.pack !== pack) continue;
        if (hasFlavor && v.flavor !== flavor) continue;
        return v;
      }
      return null;
    }
    function stripsFor(pack) {
      if (!showPerStrip) return null;
      var m = String(pack).match(/\d+/);
      if (!m) return null;
      return parseInt(m[0], 10) * stripsUnit;
    }
    function packHasSub(pack) {
      var v = variantFor(state.flavor, pack);
      return !!(v && v.sub);
    }
    /* the selling-plan allocation for a variant at the currently chosen frequency */
    function subFor(v, freqLabel) {
      var list = subsOf(v);
      if (!list.length) return null;
      for (var i = 0; i < list.length; i++) { if (list[i].label === freqLabel) return list[i]; }
      return list[0];
    }
    /* badge/meta lookup — lenient so "4-pack" matches "4-Pack (40ct)" */
    function metaFor(pack) {
      if (packMeta[pack]) return packMeta[pack];
      var pl = String(pack).toLowerCase();
      for (var k in packMeta) {
        if (!packMeta.hasOwnProperty(k)) continue;
        var kl = String(k).toLowerCase();
        if (kl && (pl.indexOf(kl) >= 0 || kl.indexOf(pl) >= 0)) return packMeta[k];
      }
      return {};
    }

    /* elements */
    var modeBtns = $$("[data-mode-btn]", root);
    var flavorBtns = $$("[data-flavor-btn]", root);
    var poptEls = $$(".popt", root);
    var ctaEls = $$("[data-cta]", root);
    var planImg = $("[data-plan-img]", root);
    var flavorNameEl = $("[data-flavor-name]", root);
    var flavorDescEl = $("[data-flavor-desc]", root);
    var buybarInfo = $("[data-buybar-info]", root);
    var errorEl = $("[data-error]", root);
    var freqRow = $("[data-freq-row]", root);
    var freqOptsEl = $("[data-freq-opts]", root);
    var noteEl = $("[data-plan-note]", root);
    var freqSelect = null;

    /* build the delivery-frequency dropdown once (defaults to the first = every month) */
    if (freqOptsEl && freqs.length) {
      var sel = document.createElement("select");
      sel.className = "plan__freq-select";
      sel.setAttribute("data-freq-select", "");
      sel.setAttribute("aria-label", "delivery frequency");
      freqs.forEach(function (f) {
        var o = document.createElement("option");
        o.value = f;
        o.textContent = freqClean(f);
        sel.appendChild(o);
      });
      sel.value = state.freq;
      sel.addEventListener("change", function () { state.freq = sel.value; render(); });
      freqOptsEl.appendChild(sel);
      freqSelect = sel;
    }

    function showError(msg) {
      if (!errorEl) return;
      errorEl.textContent = msg || "";
      errorEl.classList.toggle("is-shown", !!msg);
    }

    function render() {
      var sub = state.mode === "subscribe" && hasSub;

      /* subscribe mode: current pack must have a plan; otherwise bump */
      if (sub && !packHasSub(state.pack)) {
        var bumped = null;
        for (var i = 0; i < packs.length; i++) { if (packHasSub(packs[i])) { bumped = packs[i]; break; } }
        if (bumped) { state.pack = bumped; } else { state.mode = "onetime"; sub = false; }
      }

      modeBtns.forEach(function (b) { b.setAttribute("aria-pressed", attr(b, "data-mode-btn") === state.mode); });
      flavorBtns.forEach(function (b) { b.setAttribute("aria-pressed", attr(b, "data-flavor-btn") === state.flavor); });

      /* delivery frequency: only in subscribe mode, and only when there's a real choice (2+) */
      if (freqs.length && freqs.indexOf(state.freq) < 0) state.freq = freqs[0];
      if (freqRow) freqRow.style.display = (sub && freqs.length > 1) ? "" : "none";
      if (freqSelect) freqSelect.value = state.freq;

      /* trust row (free shipping · skip/cancel · ships in 2 days) is a subscribe-only perk line */
      if (noteEl) noteEl.style.display = sub ? "" : "none";

      poptEls.forEach(function (opt) {
        var pack = attr(opt, "data-pack");
        var v = variantFor(state.flavor, pack);
        var meta = metaFor(pack);
        var hideForSub = sub && !(v && v.sub);
        opt.style.display = hideForSub ? "none" : "";
        opt.classList.toggle("is-disabled", hideForSub);

        if (!v) { opt.style.display = "none"; return; }

        var vAlloc = subFor(v, state.freq);
        var price = (sub && vAlloc) ? vAlloc.price : v.price;
        var mainB = $(".popt__main b", opt);
        var mainSpan = $(".popt__main span", opt);
        var priceB = $(".popt__price b", opt);
        var priceS = $(".popt__price s", opt);
        var badge = $(".popt__badge", opt);

        if (mainB) mainB.textContent = pack;
        /* subline: per-strip price only (count already in the pack title) */
        var bits = [];
        var strips = stripsFor(pack);
        if (strips && price) bits.push(money(Math.round(price / strips)) + " " + perStripSuffix);
        /* free-shipping note moved out of this subline into the trust row under the buttons */
        if (mainSpan) mainSpan.textContent = bits.join(" · ");

        if (priceB) priceB.textContent = money(price);
        if (priceS) {
          var strike = "";
          if (sub && vAlloc) strike = money(v.price);
          else if (!sub && v.compareAt) strike = money(v.compareAt);
          priceS.textContent = strike;
          priceS.style.display = strike ? "" : "none";
        }
        if (badge) {
          badge.textContent = meta.badge || "";
          badge.style.display = meta.badge ? "" : "none";
        }
        opt.setAttribute("aria-pressed", pack === state.pack && !hideForSub);
        if (!v.available) opt.classList.add("is-disabled");
      });

      /* current selection */
      var cur = variantFor(state.flavor, state.pack);
      var curAlloc = subFor(cur, state.freq);
      var curPrice = cur ? ((sub && curAlloc) ? curAlloc.price : cur.price) : 0;
      var strips = stripsFor(state.pack);
      var perStr = (strips && curPrice) ? money(Math.round(curPrice / strips)) + " " + perStripSuffix : "";

      /* CTA label */
      var qty = state.qty || 1;
      var linePrice = curPrice * qty;

      /* mirror quantity for other scripts (daps-intl.js reads this so the
         free-shipping bar measures the whole line) */
      root.setAttribute("data-qty", qty);
      if (qtyVal) qtyVal.textContent = qty;

      var ctaLabel;
      if (!cur || !cur.available) ctaLabel = "sold out";
      else ctaLabel = (sub ? labelSub : labelOne) + " — " + money(linePrice);
      ctaEls.forEach(function (c) {
        if (c.hasAttribute("data-buybar-cta-plain")) c.textContent = (cur && cur.available) ? (sub ? "subscribe" : "add to cart") : "sold out";
        else c.textContent = ctaLabel;
        c.disabled = !(cur && cur.available);
      });

      /* variant image */
      if (planImg && cur && cur.image) {
        planImg.style.opacity = "0";
        setTimeout(function () { planImg.src = cur.image; planImg.style.opacity = "1"; }, 120);
      }

      /* pdp flavor name + description */
      if (flavorNameEl) flavorNameEl.textContent = state.flavor;
      if (flavorDescEl) flavorDescEl.innerHTML = flavorDescLC[String(state.flavor).toLowerCase()] || "";

      /* sticky buy bar — kept short so it never crowds a 375px screen:
         line 1 "80-strip · $39.59", line 2 the deal (sub) or per-strip (one-time),
         button just "subscribe" / "add to cart" */
      if (buybarInfo) {
        var b = $("b", buybarInfo), s = $("span", buybarInfo);
        if (b) b.textContent = String(state.pack).replace(/[\s-]*pack$/i, "") + " · " + money(linePrice);
        if (s) s.textContent = sub ? "10% off · free shipping" : (perStr || "one-time");
      }

      /* let the PDP gallery mirror the flavor's variant image */
      if (cur && cur.image) {
        root.dispatchEvent(new CustomEvent("daps:flavorchange", { bubbles: true, detail: { flavor: state.flavor, image: cur.image } }));
      }

      showError("");
      set(LSK, JSON.stringify({ flavor: state.flavor, pack: state.pack, mode: state.mode }));
    }

    /* events */
    modeBtns.forEach(function (b) {
      b.addEventListener("click", function () { state.mode = attr(b, "data-mode-btn"); render(); });
    });
    flavorBtns.forEach(function (b) {
      b.addEventListener("click", function () { state.flavor = attr(b, "data-flavor-btn"); render(); });
    });
    poptEls.forEach(function (opt) {
      var choose = function () {
        if (opt.style.display === "none") return;
        state.pack = attr(opt, "data-pack"); render();
      };
      opt.addEventListener("click", choose);
      opt.addEventListener("keydown", function (e) {
        if (e.key === "Enter" || e.key === " ") { e.preventDefault(); choose(); }
      });
    });

    /* ---- add to cart ---- */
    var adding = false;
    function addToCart() {
      if (adding) return;
      var sub = state.mode === "subscribe" && hasSub;
      var cur = variantFor(state.flavor, state.pack);
      if (!cur || !cur.available) { showError("that option is currently unavailable."); return; }
      var payload = { items: [{ id: cur.id, quantity: state.qty || 1 }] };
      var addAlloc = subFor(cur, state.freq);
      if (sub && addAlloc) payload.items[0].selling_plan = addAlloc.id;

      adding = true;
      ctaEls.forEach(function (c) { c.dataset._t = c.textContent; c.textContent = "adding…"; c.disabled = true; });

      fetch(cartAddUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json", "Accept": "application/json" },
        body: JSON.stringify(payload)
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j && j.description || "add failed"); });
        return r.json();
      }).then(function () {
        return fetch("/cart.js", { headers: { "Accept": "application/json" } }).then(function (r) { return r.json(); });
      }).then(function (cart) {
        updateCartCount(cart.item_count);
        adding = false;
        if (afterAdd === "checkout") { window.location.href = "/checkout"; return; }
        if (afterAdd === "cart") {
          /* Prefer the slide-out cart: no page bounce, and the free-shipping
             progress + gap-closing offer live there. Falls back to the cart
             page if the drawer script is absent. */
          if (window.dapsCart && typeof window.dapsCart.open === "function") {
            ctaEls.forEach(function (c) { if (c.dataset._t) c.textContent = c.dataset._t; c.disabled = false; });
            window.dapsCart.open();
            return;
          }
          window.location.href = cartUrl;
          return;
        }
        /* stay: confirm inline */
        ctaEls.forEach(function (c) { c.textContent = "added ✓"; c.disabled = false; });
        setTimeout(render, 1400);
      }).catch(function (err) {
        adding = false;
        ctaEls.forEach(function (c) { if (c.dataset._t) c.textContent = c.dataset._t; c.disabled = false; });
        showError((err && err.message) || "sorry — couldn't add to cart. try again.");
      });
    }
    /* quantity stepper — clamps 1..QTY_MAX then re-renders. It touches only
       state.qty; variant + selling-plan resolution is untouched. */
    qtySteps.forEach(function (b) {
      b.addEventListener("click", function () {
        var step = parseInt(attr(b, "data-qty-step"), 10) || 0;
        var next = (state.qty || 1) + step;
        if (next < 1) next = 1;
        if (next > QTY_MAX) next = QTY_MAX;
        if (next === state.qty) return;
        state.qty = next;
        render();
      });
    });

    $$("[data-add]", root).forEach(function (b) { b.addEventListener("click", addToCart); });

    /* mark the plain sticky-bar CTA so it shows a short label */
    var stickyCta = $(".buybar [data-cta]", root);
    if (stickyCta) stickyCta.setAttribute("data-buybar-cta-plain", "");
    if ($(".buybar", root)) document.body.classList.add("has-buybar");

    /* scroll-triggered sticky bar — main site only (landing pages have no .nav and
       keep the always-visible bar): home → show only after the #reviews section has
       been scrolled past; pdp → show once the buy box (.plan) is scrolled past and
       hide again whenever it's back on screen. */
    var buybarEl = $(".buybar", root);
    if (buybarEl && document.querySelector(".nav")) {
      var stickyTrigger = placement === "pdp" ? $(".plan", root) : document.querySelector("#reviews");
      if (stickyTrigger) {
        var barShown = function (on) {
          /* opacity too: a merely-translated bar still peeks through iOS Safari's
             translucent floating URL bar, which overlays the zone below the viewport */
          buybarEl.style.transform = on ? "" : "translateY(110%)";
          buybarEl.style.opacity = on ? "" : "0";
          buybarEl.style.pointerEvents = on ? "" : "none";
        };
        buybarEl.style.transition = "transform .25s ease, opacity .25s ease";
        var barUpdate = function () { barShown(stickyTrigger.getBoundingClientRect().bottom < 0); };
        window.addEventListener("scroll", barUpdate, { passive: true });
        window.addEventListener("resize", barUpdate);
        barUpdate();
      }
    }

    render();
  }

  /* nav cart count */
  function updateCartCount(count) {
    $$("[data-cart-count]").forEach(function (el) {
      el.textContent = count;
      el.style.transform = "scale(1.3)";
      setTimeout(function () { el.style.transform = ""; }, 180);
    });
  }

  function boot() { $$("[data-buy-root]").forEach(initModule); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", boot);
  else boot();

  /* re-init when a section is edited in the Theme Editor */
  document.addEventListener("shopify:section:load", boot);
})();
